import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2, HeartPulse, Calendar } from 'lucide-react';
const tableData = [{
  icon: '🩻',
  situation: 'Alumna con lumbalgia crónica',
  without: 'Improvisás o evitás ciertas posturas',
  with: 'Protocolo exacto: qué hacer, qué no, qué decir'
}, {
  icon: '🤰',
  situation: 'Alumna embarazada',
  without: 'Miedo a lastimar o quedar mal',
  with: 'Guía por trimestre con posturas adaptadas'
}, {
  icon: '🦴',
  situation: 'Alumno con prótesis de cadera',
  without: 'No sabés qué está contraindicado',
  with: 'Lista de restricciones y adaptaciones por condición'
}, {
  icon: '🦷',
  situation: 'Alumna con osteoporosis',
  without: 'Evitás todo por las dudas',
  with: 'Protocolo claro de qué sí y qué no según el grado'
}, {
  icon: '😰',
  situation: 'Alumno con ansiedad o estrés severo',
  without: 'No sabés cómo modular la clase',
  with: 'Secuencia específica con respiración y progresión segura'
}, {
  icon: '🚨',
  situation: 'Situación de urgencia en clase',
  without: 'Pánico y sin saber qué hacer',
  with: 'Protocolo de emergencia paso a paso listo para actuar'
}, {
  icon: '🆕',
  situation: 'Alumno nuevo con condición especial',
  without: 'La ficha no te dice qué hacer con eso',
  with: 'Tabla de equivalencias: si el PDF dice X, hacé Y para esa condición'
}];
export function YogaTerapeutico() {
  return <section className="py-24 bg-white" data-id="element-334">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-335">
        <div className="text-center mb-16" data-id="element-336">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-337">
            ¿QUÉ AGREGA EL{' '}
            <span className="text-yoga-purple-600" data-id="element-338">YOGA TERAPÉUTICO PRO™</span>
            ?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-339">
            El sistema de adaptaciones que hace que ningún alumno sea "demasiado
            difícil"
          </p>
        </div>

        {/* Comparison Table - matching ComparisonTable style */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200 mb-20" data-id="element-340">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-341">
            <div className="p-6 text-center font-bold text-red-600 uppercase tracking-wider text-sm" data-id="element-342">
              Sin Yoga Terapéutico Pro
            </div>
            <div className="p-6 text-center font-bold text-green-700 uppercase tracking-wider text-sm bg-green-50/50" data-id="element-343">
              Con Yoga Terapéutico Pro
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-344">
            {tableData.map((item, index) => <motion.div key={index} className="grid grid-cols-2 relative" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} data-id="element-345">
                {/* Center Icon */}
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100 z-10 text-lg" data-id="element-346">
                  {item.icon}
                </div>

                <div className="p-6 pr-8 text-right flex flex-col justify-center text-gray-600" data-id="element-347">
                  <span className="text-xs font-bold text-red-400 uppercase tracking-wider mb-1" data-id="element-348">
                    {item.situation}
                  </span>
                  <span className="text-sm md:text-base" data-id="element-349">{item.without}</span>
                </div>

                <div className="p-6 pl-8 bg-green-50/30 flex flex-col justify-center font-medium text-green-900" data-id="element-350">
                  <span className="text-xs font-bold text-green-500 uppercase tracking-wider mb-1" data-id="element-351">
                    {item.situation}
                  </span>
                  <span className="text-sm md:text-base" data-id="element-352">{item.with}</span>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Upsell Details */}
        <div className="text-center mb-12" data-id="element-353">
          <h3 className="text-2xl font-bold text-gray-900" data-id="element-354">
            YOGA TERAPÉUTICO PRO™ INCLUYE:
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-355">
          <motion.div className="bg-yoga-purple-50 rounded-2xl p-8 border border-yoga-purple-100" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-356">
            <div className="flex items-center gap-4 mb-6" data-id="element-357">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-358">
                <HeartPulse className="w-8 h-8 text-yoga-purple-600" data-id="element-359" />
              </div>
              <div data-id="element-360">
                <div className="text-sm font-bold text-yoga-purple-600 uppercase tracking-wider" data-id="element-361">
                  UPSELL 1
                </div>
                <h4 className="text-xl font-serif font-bold text-gray-900" data-id="element-362">
                  "Yoga Terapéutico — Protocolo Clínico"
                </h4>
                <div className="text-sm text-gray-500" data-id="element-363">(60 páginas)</div>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-364">
              <li className="flex items-start gap-2" data-id="element-365">
                <span className="text-yoga-gold" data-id="element-366">•</span> Qué es el yoga
                terapéutico y cómo diferenciarlo del yoga convencional
              </li>
              <li className="flex items-start gap-2" data-id="element-367">
                <span className="text-yoga-gold" data-id="element-368">•</span> Protocolos por
                patología: lumbalgia, escoliosis, estrés, insomnio, ansiedad,
                hipertensión
              </li>
              <li className="flex items-start gap-2" data-id="element-369">
                <span className="text-yoga-gold" data-id="element-370">•</span> Secuencias específicas
                para cada condición (con imágenes)
              </li>
              <li className="flex items-start gap-2" data-id="element-371">
                <span className="text-yoga-gold" data-id="element-372">•</span> Cómo trabajar con
                médicos y fisioterapeutas
              </li>
              <li className="flex items-start gap-2" data-id="element-373">
                <span className="text-yoga-gold" data-id="element-374">•</span> Contraindicaciones
                absolutas y relativas por condición
              </li>
              <li className="flex items-start gap-2" data-id="element-375">
                <span className="text-yoga-gold" data-id="element-376">•</span> Lenguaje profesional
                para comunicarte con otros profesionales de la salud
              </li>
            </ul>
          </motion.div>

          <motion.div className="bg-yoga-purple-50 rounded-2xl p-8 border border-yoga-purple-100" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-377">
            <div className="flex items-center gap-4 mb-6" data-id="element-378">
              <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-379">
                <Calendar className="w-8 h-8 text-yoga-purple-600" data-id="element-380" />
              </div>
              <div data-id="element-381">
                <div className="text-sm font-bold text-yoga-purple-600 uppercase tracking-wider" data-id="element-382">
                  UPSELL 2
                </div>
                <h4 className="text-xl font-serif font-bold text-gray-900" data-id="element-383">
                  "Programa de 8 Semanas — Ya Armado"
                </h4>
                <div className="text-sm text-gray-500" data-id="element-384">(60 páginas)</div>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-385">
              <li className="flex items-start gap-2" data-id="element-386">
                <span className="text-yoga-gold" data-id="element-387">•</span> Estructura del
                programa semana a semana lista para usar
              </li>
              <li className="flex items-start gap-2" data-id="element-388">
                <span className="text-yoga-gold" data-id="element-389">•</span> 8 semanas completas
                con: tema, clase lista, tarea para el alumno y progresión
              </li>
              <li className="flex items-start gap-2" data-id="element-390">
                <span className="text-yoga-gold" data-id="element-391">•</span> Cómo venderlo como
                curso online o presencial
              </li>
              <li className="flex items-start gap-2" data-id="element-392">
                <span className="text-yoga-gold" data-id="element-393">•</span> Emails de bienvenida y
                seguimiento listos para enviar
              </li>
              <li className="flex items-start gap-2" data-id="element-394">
                <span className="text-yoga-gold" data-id="element-395">•</span> Modelo de precio
                sugerido por ciudad argentina
              </li>
              <li className="flex items-start gap-2" data-id="element-396">
                <span className="text-yoga-gold" data-id="element-397">•</span> Cómo lanzarlo en
                Instagram en 7 días
              </li>
              <li className="flex items-start gap-2" data-id="element-398">
                <span className="text-yoga-gold" data-id="element-399">•</span> Sistema de inscripción
                y seguimiento de cohorte
              </li>
              <li className="flex items-start gap-2" data-id="element-400">
                <span className="text-yoga-gold" data-id="element-401">•</span> Guión de clase
                inaugural del programa
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}